import Vue from 'vue'
import Vuex from 'vuex'
import app from '../../main'
import axios from 'axios'
import checkResponse from '@/utils/checkResponse'

Vue.use(Vuex)

const state = {
  loading: false,
  order: null,
  preventiveReview: null,
  correctiveReview: null,
  details: [],
  errorCatalogs: []
}

const mutations = {
  SET_LOADING (state, payload) {
    state.loading = payload
  },
  SET_CONTEXT (state, payload) {
    state.order = payload.order
    state.preventiveReview = payload.preventive_review
    state.correctiveReview = payload.corrective_review
    state.details = payload.details || []
  },
  SET_ERROR_CATALOGS (state, payload) {
    state.errorCatalogs = payload || []
  }
}

const actions = {
  async loadErrorCatalogs ({ commit }) {
    try {
      const response = await axios.get('error-catalogs/all')
      const checkErrors = checkResponse(response)
      if (checkErrors) {
        return false
      }
      commit('SET_ERROR_CATALOGS', response.data.data || [])
      return true
    } catch (e) {
      return false
    }
  },
  async loadOrderCorrectiveContext ({ commit }, orderId) {
    commit('SET_LOADING', true)
    app.$Progress.start()
    try {
      const response = await axios.get(`orders/${orderId}/corrective-review`)
      const checkErrors = checkResponse(response)
      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
        return false
      }
      commit('SET_CONTEXT', response.data.data)
      return true
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
      return false
    } finally {
      commit('SET_LOADING', false)
      app.$Progress.finish()
    }
  },
  async createCorrectiveReview ({ commit }, { orderId, payload }) {
    app.$Progress.start()
    try {
      const response = await axios.post(`orders/${orderId}/corrective-review`, payload)
      const checkErrors = checkResponse(response)
      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
        return false
      }
      commit('SET_ACCEPT_ALERT', { color: 'success', title: 'Correctivo guardado', icon: 'checkmark-circle-outline' }, { root: true })
      return true
    } catch (e) {
      app.$Progress.fail()
      const status = e.response && e.response.status
      if (status === 409) {
        commit('SET_ALERT_MESSAGE', { color: 'warning', title: 'Correctivo existente', text: 'Esta orden ya tiene revisión correctiva.' }, { root: true })
      } else if (status === 422) {
        commit('SET_ALERT_MESSAGE', { color: 'warning', title: 'No se pudo guardar', text: 'Revisa los datos e intenta de nuevo.' }, { root: true })
      } else if (status === 404) {
        commit('SET_ALERT_MESSAGE', { color: 'warning', title: 'No encontrado', text: 'No se encontró el recurso.' }, { root: true })
      } else {
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
      }
      return false
    } finally {
      app.$Progress.finish()
    }
  },
  async updateCorrectiveReview ({ commit }, { orderId, payload }) {
    app.$Progress.start()
    try {
      const response = await axios.patch(`orders/${orderId}/corrective-review`, payload)
      const checkErrors = checkResponse(response)
      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
        return false
      }
      commit('SET_ACCEPT_ALERT', { color: 'success', title: 'Correctivo actualizado', icon: 'checkmark-circle-outline' }, { root: true })
      return true
    } catch (e) {
      app.$Progress.fail()
      const status = e.response && e.response.status
      if (status === 422) {
        commit('SET_ALERT_MESSAGE', { color: 'warning', title: 'No se pudo actualizar', text: 'Revisa los datos e intenta de nuevo.' }, { root: true })
      } else if (status === 404) {
        commit('SET_ALERT_MESSAGE', { color: 'warning', title: 'No encontrado', text: 'No se encontró revisión correctiva para esta orden.' }, { root: true })
      } else {
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
      }
      return false
    } finally {
      app.$Progress.finish()
    }
  }
}

const getters = {
  loading: state => state.loading,
  order: state => state.order,
  preventiveReview: state => state.preventiveReview,
  correctiveReview: state => state.correctiveReview,
  details: state => state.details,
  errorCatalogs: state => state.errorCatalogs
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
